import { type Chart, type Plugin } from "chart.js";
import { set } from "lodash";
import { type ChartJSOrUndefined } from "react-chartjs-2/dist/types";

import { type Annotation } from "@features/custom-annotations";

export const CHART_DATA_MANAGER_ID = "chartDataManager";

export type ChartDataManagerPluginOptions = {
  data: { datasets: any[] };
  dateRange: {
    startDate: string;
    endDate: string;
  };
  inSampleData: {
    startDate: Date;
    endDate: Date;
    mape?: number;
  };
  outOfSampleData: {
    startDate: Date;
    endDate: Date;
    mape?: number;
  };
  pageConfiguration: {
    timezone: string;
  };
  calendarOfEvents: Annotation[];
};

export const chartDataManagerPlugin: Plugin = {
  id: CHART_DATA_MANAGER_ID,
};

export const getChartData = (
  chart: Chart<any>,
): ChartDataManagerPluginOptions =>
  chart.config.options.plugins[CHART_DATA_MANAGER_ID];

export const setChartData = (
  chart: ChartJSOrUndefined | null,
  chartDataManager: ChartDataManagerPluginOptions,
) => {
  if (!chart) {
    return;
  }

  set(
    chart,
    `config.options.plugins.${CHART_DATA_MANAGER_ID}`,
    chartDataManager,
  );

  applyCalendarEventBands(chart, chartDataManager);

  try {
    chart.update();
  } catch (e) {
    console.error(e);
  }
};

const applyCalendarEventBands = (
  chart: Chart,
  chartDataManager: ChartDataManagerPluginOptions,
) => {
  if (chartDataManager.calendarOfEvents.length) {
    chartDataManager.calendarOfEvents.forEach((annotation) => {
      const annotations =
        chart.config.options?.plugins?.annotation?.annotations;

      if (annotations) {
        (annotations as Record<string, any>)[`COE-${annotation.id}`] = {
          type: "box",
          scaleID: "x",
          xMin: annotation.annotatedDate,
          xMax: annotation.endDate,
          backgroundColor: "rgba(181, 185, 192, 0.3)",
          borderColor: "rgba(181, 185, 192, 0.3)",
        };
      }
    });
  }
};
